(function(){
    'use strict';
    angular.module('Directives').directive('bbaBreakBulkDetailsDirective', bbaBreakBulkDetailsDirective);

    bbaBreakBulkDetailsDirective.$inject = [];

    function bbaBreakBulkDetailsDirective() {
        return {
            retrict: 'E',
            templateUrl: '/templates/directives/components/shipment-details/bba-break-bulk-details.html',
            scope: {
                breakBulkLabel: "=",
                breakBulkData: "="
            },
            link: bbaBreakBulkDetailsDirectiveLink
        }

        function bbaBreakBulkDetailsDirectiveLink(scope, elements, attr) {
            scope.data = scope.breakBulkData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/shipment-details/breakBulkDetailsDirective.js